module.exports = __webpack_public_path__ + "static/media/qr.6f9329df.PNG";